module.exports = __webpack_public_path__ + "static/media/nl.31c8eba0.svg";